export class GeoTileSystemTileIndex {level: any;j: any;i: any;
  
  constructor(level:any,i:any,j:any){
    this.i=i;
    this.j=j;
    this.level=level;
  }
}